import { render, staticRenderFns } from "./Unsupported.vue?vue&type=template&id=132f124b&scoped=true&"
import script from "./Unsupported.vue?vue&type=script&lang=js&"
export * from "./Unsupported.vue?vue&type=script&lang=js&"
import style0 from "./Unsupported.vue?vue&type=style&index=0&id=132f124b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f124b",
  null
  
)

export default component.exports